import React from 'react'
import styled from 'styled-components'
import { Colors } from '../../constants'
import { DownChevron } from '../icons'

interface Props {
  onClick: () => void
}

export function TokenSelectButton({ onClick }: Props) {
  return (
    <BlackButton onClick={onClick}>
      Select a token <DownChevron />
    </BlackButton>
  )
}

const BlackButton = styled.button`
  white-space: nowrap;
  color: ${Colors.White};
  background-color: ${Colors.Black};
  border: none;
  outline: none;
  padding: 6px 12px;
  cursor: pointer;
`
